<!-- Upgrade Banner -->
<button pButton [label]="'upgradeAccount.unlockAllFeatures' | transloco" icon="pi pi-lock-open" class="p-button-outlined upgrade-btn" (click)="openUpgradeModal()"></button>

<!-- Upgrade Modal -->
@if (showUpgradeModal) {
  <div class="modal-overlay" (click)="closeUpgradeModal()">
    <div class="modal-content" (click)="$event.stopPropagation()">
      <button class="modal-close" (click)="closeUpgradeModal()" [disabled]="isUpgrading">
        <i class="pi pi-times"></i>
      </button>
      <!-- Modal Body - Simplified -->
      <div class="modal-body-simple">
        <!-- ArtFlow Logo -->
        <div class="logo-container">
          <img src="assets/images/thumb_AFP-logo-v02-noTagline-800.png" [alt]="'upgradeAccount.artflow' | transloco" class="artflow-logo">
        </div>
        <!-- Main Message -->
        <h2 class="upgrade-title">{{ 'upgradeAccount.upgradeYourAccount' | transloco }}</h2>
        <p class="upgrade-subtitle">{{ 'upgradeAccount.upgradeSubtitle' | transloco }}</p>
        <!-- Free Badge -->
        <div class="free-badge">
          <i class="pi pi-check-circle"></i>
          <span>{{ 'upgradeAccount.itsCompletely' | transloco }} <strong>{{ 'upgradeAccount.free' | transloco }}</strong></span>
        </div>
        <!-- Info Box -->
        <div class="upgrade-info">
          <i class="pi pi-info-circle"></i>
          <p>{{ 'upgradeAccount.upgradeInfo' | transloco }}</p>
        </div>
        <!-- Action Buttons -->
        <div class="upgrade-actions">
          <button pButton [label]="'upgradeAccount.maybeLater' | transloco" class="p-button-outlined btn-cancel"
            (click)="closeUpgradeModal()"
            [disabled]="isUpgrading">
          </button>
          <button pButton [label]="'upgradeAccount.upgradeNow' | transloco" icon="pi pi-arrow-up" class="p-button-outlined btn-upgrade"
            (click)="upgradeAccount()"
            [disabled]="isUpgrading">
          </button>
        </div>
      </div>
    </div>
  </div>
}

